import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface PackageCourseListFooterProps {
  total?: string;
}

export function PackageCourseListFooter({ total }: PackageCourseListFooterProps) {
  return (
    <Stack direction="row" justifyContent="flex-end" padding={1}>
      <Typography variant="h5">Total Package Cost: {total}</Typography>
    </Stack>
  );
}

export default PackageCourseListFooter;
